import { render, staticRenderFns } from "./CalculatorDeliveriesItem.vue?vue&type=template&id=8c09fd72&scoped=true&"
import script from "./CalculatorDeliveriesItem.vue?vue&type=script&lang=ts&"
export * from "./CalculatorDeliveriesItem.vue?vue&type=script&lang=ts&"
import style0 from "./CalculatorDeliveriesItem.vue?vue&type=style&index=0&id=8c09fd72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c09fd72",
  null
  
)

export default component.exports